/**
 * Rate-card form input helpers (TMMPDM-0009; TMMPDM-0089 keeps only what the Prices tab and the other
 * money forms use): a major-unit input → integer minor units, and the client-side shape checks.
 * Conversions on input only.
 */
import { minorUnitDigits } from '@/format';

/** The codes a rate card (and an agreement's minimum) can be in; the same list since TMMPDM-0009. */
export const CURRENCIES = ['USD', 'CRC', 'MXN', 'EUR', 'GBP', 'CAD'] as const;

/** A typed major-unit amount → integer minor units in `currency` (0 when it isn't a number). */
export function parseMajor(major: string, currency: string): number {
  const n = Number(major);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 10 ** minorUnitDigits(currency));
}

export function invalidMoney(value: string): boolean {
  if (value.trim() === '') return true;
  const n = Number(value);
  return !Number.isFinite(n) || n < 0;
}

export function invalidInt(value: string): boolean {
  if (value.trim() === '') return true;
  const n = Number(value);
  return !Number.isInteger(n) || n < 0;
}

export function invalidPct(value: string): boolean {
  if (value.trim() === '') return true;
  const n = Number(value);
  return !Number.isFinite(n) || n < 0;
}

/**
 * A percent from 0 to 100 with at most two decimals, sent as basis points 0–10000 (the credit share,
 * a processing fee's percent).
 */
export function invalidPercent(value: string): boolean {
  const trimmed = value.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return true;
  return Number(trimmed) > 100;
}
